import moment from 'moment';

export function normalizeDiscounts(discounts) {
  return discounts.map(i => ({
    ...i,
    discount: {
      ...i.discount,
      start: moment.utc(i.start),
      end: moment.utc(i.end),
    },
    applied_at: moment.utc(i.applied_at),
    removed_at: moment.utc(i.removed_at),
  }));
}
